import React from "react";
import Topbar from "../../components/TopbarNav";
import Sidebar from "../../components/MasterSideBar";
import menuItems from "../../menuitems/menuItems.js";


const handleLogout = () => {
  localStorage.removeItem("token");
  window.location.href = "/";
};
function DisciplinaryInterfaceManager() {
  return (
    <div className="flex">
      {/* Sidebar */}
      <div className="w-64 fixed h-screen z-50">
        <Sidebar menuItems={menuItems} />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 ml-64">
        {/* Topbar */}
        <div className="fixed top-0 left-64 right-0 z-40">
          <Topbar />
        </div>


      </div>
    </div>
  );
}

export default DisciplinaryInterfaceManager;
